(function () {
  var MB_HOST = "https://multibuy-minos.vercel.app"; // beim Kopieren für neuen Shop anpassen

  function fmt(n) {
    return n.toFixed(2).replace(".", ",") + " €";
  }

  function renderPrices(widget) {
    var price = parseFloat(widget.dataset.price);
    widget.querySelectorAll(".mb-tile").forEach(function (tile) {
      var qty = parseInt(tile.dataset.qty, 10);
      var type = tile.dataset.type;
      var value = parseFloat(tile.dataset.value) || 0;
      var cents = Math.round(price * 100);
      var full = (cents * qty) / 100;
      // Wie Shopify: Prozent-Rabatt pro Stück, auf Cent ABgerundet
      var final =
        type === "percent" ? ((cents - Math.floor((cents * value) / 100)) * qty) / 100
        : type === "amount" ? Math.max(0, full - value)
        : full;
      var savedEuro = (full - final).toFixed(2).replace(".", ",");
      var mode = widget.dataset.saveDisplay || "percent";
      var save = "";
      if (type === "amount") {
        save = widget.dataset.saveAmt.replace("{amt}", savedEuro);
      } else if (type === "percent") {
        var pctText = widget.dataset.savePct.replace("{pct}", value);
        save =
          mode === "amount" ? widget.dataset.saveAmt.replace("{amt}", savedEuro)
          : mode === "both" ? pctText + " (" + savedEuro + " €)"
          : pctText;
      }
      tile.querySelector(".mb-price").innerHTML =
        (type !== "none" ? "<s>" + fmt(full) + "</s>" : "") +
        "<b>" + fmt(final) + "</b>" +
        (save ? '<span class="mb-save">' + save + "</span>" : "");
      // Grundpreis (falls Produkt einen hat): auf Basis des rabattierten Preises
      var unitEl = tile.querySelector(".mb-unit");
      var unitBase = parseFloat(widget.dataset.unitBase);
      if (unitEl && unitBase && price > 0) {
        var unitNow = (final / qty) * (unitBase / price);
        unitEl.textContent = fmt(unitNow) + " / " + widget.dataset.unitLabel;
      }
    });
  }

  function selectedTile(widget) {
    return widget.querySelector(".mb-tile.mb-selected") || widget.querySelector(".mb-tile");
  }

  function setBusy(form, busy) {
    var btn = form.querySelector('[type="submit"], button[name="add"]');
    if (!btn) return;
    btn.disabled = busy;
    btn.setAttribute("aria-busy", busy ? "true" : "false");
    btn.classList.toggle("loading", busy);
    var spinner = btn.querySelector(".loading__spinner");
    if (spinner) spinner.classList.toggle("hidden", !busy);
  }

  // cart/update.js ERSETZT die komplette Code-Liste des Warenkorbs. Wird nur der neue
  // Code gesendet, verliert der zuvor per Widget gekaufte Artikel seinen Rabatt ("der
  // Rabatt springt zum zuletzt hinzugefügten Artikel"). Deshalb die vorhandenen Codes
  // kommagetrennt mitschicken. Nicht anwendbare Codes (abgelaufen/verbraucht) fallen
  // raus; fehlt das Feld `applicable`, wird der Code behalten.
  async function mbApplyCode(code) {
    var root = window.Shopify.routes.root;
    var cart = await fetch(root + "cart.js").then(function (r) { return r.json(); }).catch(function () { return {}; });
    var base = cart.total_discount || 0;
    var list = (cart.discount_codes || [])
      .filter(function (d) { return d.applicable !== false && d.code !== code; })
      .map(function (d) { return d.code; })
      .concat(code)
      .join(",");
    // Frische Codes brauchen ~2s Shopify-Propagation: anwenden, prüfen, ggf. wiederholen.
    for (var attempt = 0; attempt < 5; attempt++) {
      var upd = await fetch(root + "cart/update.js", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ discount: list }),
      }).then(function (r) { return r.json(); }).catch(function () { return {}; });
      var applied = (upd.discount_codes || []).some(function (d) {
        return d.code === code && d.applicable;
      });
      if (applied) break;
      if ((upd.total_discount || 0) > base) break;
      await new Promise(function (r) { setTimeout(r, 700); });
    }
  }

  // Krown-"Local"-Theme: Cart-Sidebar aus gerendertem helper-cart-HTML aktualisieren.
  // openAfter=false tauscht nur still die Inhalte — der Rabatt trifft erst nach ~2s
  // Shopify-Propagation ein; ein erneutes show() würde eine vom Kunden bereits
  // geschlossene Sidebar wieder aufreißen.
  function updateSidebar(html, openAfter) {
    var sidebar = document.getElementById("site-cart-sidebar");
    var ajaxForm = document.getElementById("AjaxCartForm");
    if (!sidebar || !ajaxForm || !html) return false;
    var doc = new DOMParser().parseFromString(html, "text/html");
    var srcForm = doc.getElementById("AjaxCartForm");
    if (!srcForm) return false;
    ajaxForm.innerHTML = srcForm.innerHTML;
    if (typeof ajaxForm.ajaxifyCartItems === "function") ajaxForm.ajaxifyCartItems();
    var subEl = document.getElementById("AjaxCartSubtotal");
    var subNew = doc.getElementById("AjaxCartSubtotal");
    if (subEl && subNew) subEl.innerHTML = subNew.innerHTML;
    var barEl = document.getElementById("AjaxShippingBar");
    var barNew = doc.getElementById("AjaxShippingBar");
    if (barEl && barNew) barEl.innerHTML = barNew.innerHTML;
    var cnt = ajaxForm.querySelector("[data-cart-count]");
    if (cnt) document.querySelectorAll("[data-header-cart-count]").forEach(function (el) { el.textContent = cnt.textContent; });
    var tot = ajaxForm.querySelector("[data-cart-total]");
    if (tot) document.querySelectorAll("[data-header-cart-total]").forEach(function (el) { el.textContent = tot.textContent; });
    if (openAfter) {
      // Cross-Sells neu erzeugen. Das Theme macht das sonst am "add-to-cart"-Event
      // (section-main-product.js) bzw. nach Cart-Updates (component-cart.js) — beide
      // Pfade laufen hier nicht, weil MultiBuy den Submit ab 2 Stück selbst übernimmt.
      // Muss NACH dem Ersetzen von AjaxCartForm laufen: generateRecommendations()
      // liest die Produkt-ID aus der ersten Warenkorbzeile.
      var recs = document.querySelector("cart-recommendations");
      if (recs && typeof recs.generateRecommendations === "function") {
        recs.innerHTML = "";
        recs.generateRecommendations();
      }
      if (typeof sidebar.show === "function") sidebar.show();
    }
    return true;
  }

  async function buy(widget, form) {
    if (widget.dataset.mbBusy === "1") return; // Doppelklick-Schutz
    widget.dataset.mbBusy = "1";
    setBusy(form, true); // sofortiges Feedback: Spinner an, Button gesperrt
    try {
      var tile = selectedTile(widget);
      var qty = parseInt(tile.dataset.qty, 10);
      var type = tile.dataset.type;
      var variantId = form.querySelector('[name="id"]').value;
      var root = window.Shopify.routes.root;

      // Code-Erzeugung und Warenkorb-Add laufen PARALLEL
      var codePromise = Promise.resolve(null);
      if (type !== "none") {
        codePromise = fetch(MB_HOST + "/api/code", {
          method: "POST",
          headers: { "content-type": "application/json" },
          body: JSON.stringify({ dealId: widget.dataset.dealId, qty: qty, variantId: Number(variantId), productId: Number(widget.dataset.productId) }),
        })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (j) { return j && j.code; })
          .catch(function () { return null; }); // Fallback: ohne Code fortfahren
      }
      // Artikel + Sidebar-HTML in EINEM Request (Section Rendering von cart/add.js)
      var added = await fetch(root + "cart/add.js", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: qty }],
          sections: "helper-cart",
          sections_url: window.location.pathname,
        }),
      }).then(function (r) { return r.json(); }).catch(function () { return {}; });

      // Sidebar SOFORT öffnen — der Rabatt wird angewendet, während der Kunde schaut
      var opened = updateSidebar(added.sections && added.sections["helper-cart"], true);
      if (!opened) {
        // Keine Ajax-Sidebar (oder Section Rendering fehlgeschlagen): Rabatt anwenden,
        // dann klassisch zur Warenkorb-Seite
        var c = await codePromise;
        if (c) await mbApplyCode(c);
        window.location.href = root + "cart";
        return;
      }

      var code = await codePromise;
      if (code) {
        await mbApplyCode(code);
        // Rabattierte Preise in die bereits offene Sidebar nachziehen
        var text = await fetch("?section_id=helper-cart").then(function (r) { return r.text(); }).catch(function () { return null; });
        updateSidebar(text, false);
      }
    } finally {
      setBusy(form, false);
      widget.dataset.mbBusy = "";
    }
  }

  document.querySelectorAll(".mb-widget").forEach(function (widget) {
    if (widget.dataset.mbInit) return;
    widget.dataset.mbInit = "1";
    renderPrices(widget);

    var qtyBadge = widget.dataset.qtyBadge;
    if (qtyBadge) {
      widget.querySelectorAll(".mb-tile").forEach(function (tile) {
        var el = tile.querySelector(".mb-qtybadge");
        if (el) el.textContent = qtyBadge.replace("{qty}", tile.dataset.qty);
      });
    }

    widget.querySelectorAll(".mb-tile").forEach(function (tile) {
      tile.addEventListener("click", function () {
        widget.querySelectorAll(".mb-tile").forEach(function (t) { t.classList.remove("mb-selected"); });
        tile.classList.add("mb-selected");
      });
    });

    var form = document.getElementById(widget.dataset.formId);
    if (!form) return;
    form.addEventListener("submit", function (e) {
      var tile = selectedTile(widget);
      if (parseInt(tile.dataset.qty, 10) <= 1) return; // Standardverhalten
      e.preventDefault();
      e.stopImmediatePropagation();
      buy(widget, form);
    }, true);

    // Preis bei Variantenwechsel aktualisieren
    document.addEventListener("change", function (e) {
      if (!form.contains(e.target) && !e.target.closest("variant-selects, variant-radios, product-variants")) return;
      var priceEl = document.querySelector('[id^="price-"] .price-item--regular, [id^="price-"] .price-item--sale, [data-js-product-price-extended] [data-js-product-price-original]');
      if (priceEl) {
        var raw = priceEl.textContent.replace(/[^\d,\.]/g, "").replace(",", ".");
        var p = parseFloat(raw);
        if (!isNaN(p)) { widget.dataset.price = p; renderPrices(widget); }
      }
    });
  });
})();
